import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Button from '../Components/Button';
import Typography from '../Components/Typography';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import LoyaltyOutlinedIcon from '@mui/icons-material/LoyaltyOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

const item: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	px: 5,
};

const number = {
	fontSize: 24,
	fontFamily: 'default',
	color: 'secondary.main',
	fontWeight: 'medium',
};

export const ProductHowItWorks = () => {
	return (
		<Box
			component="section"
			sx={{
				display: 'flex',
				bgcolor: 'secondary.light',
				overflow: 'hidden',
			}}
			id="howitworks"
		>
			<Container
				sx={{
					mt: 10,
					mb: 15,
					position: 'relative',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				<Typography
					variant="h4"
					marked="center"
					align="center"
					component="h2"
					paddingBottom={5}
				>
					How It Works
				</Typography>
				<div>
					<Grid container spacing={5}>
						<Grid item xs={12} md={4}>
							<Box sx={item}>
								<Box sx={number}>1.</Box>
								<CalendarMonthOutlinedIcon
									sx={{ fontSize: 70 }}
								/>
								<Typography variant="h5" align="center">
									Appointment every Wednesday 9am.
								</Typography>
							</Box>
						</Grid>
						<Grid item xs={12} md={4}>
							<Box sx={item}>
								<Box sx={number}>2.</Box>
								<LoyaltyOutlinedIcon sx={{ fontSize: 70 }} />
								<Typography variant="h5" align="center">
									First come, first served. Our offers are in
									limited quantities, so be quick.
								</Typography>
							</Box>
						</Grid>
						<Grid item xs={12} md={4}>
							<Box sx={item}>
								<Box sx={number}>3.</Box>
								<CampaignOutlinedIcon sx={{ fontSize: 70 }} />
								<Typography variant="h5" align="center">
									{
										'New offers every week. New experiences, new surprises.Your Sundays will no longer be alike.'
									}
								</Typography>
							</Box>
						</Grid>
					</Grid>
				</div>
				<Button
					color="secondary"
					size="large"
					variant="contained"
					component="a"
					href="/signup"
					sx={{ mt: 8 }}
				>
					Get started
				</Button>
			</Container>
		</Box>
	);
};

//export default ProductHowItWorks;
